import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Taller } from '../../../../../../common/types/Taller'

/**
 * `tallerSeleccionado` es manté alineat amb `cesta.selectedTaller` (vegeu tallerSyncSagas
 * i useSyncTallerFromCesta). La cesta és la font de veritat del journey.
 */
export interface SearchNeumaticosTallerStateType {
  tallerSeleccionado: Taller | null
  talleresEncontrados: Taller[]
  loading: boolean
  error: string | null
  busqueda: string
  modalAbierto: boolean
}

export const initialState: SearchNeumaticosTallerStateType = {
  tallerSeleccionado: null,
  talleresEncontrados: [],
  loading: false,
  error: null,
  busqueda: '',
  modalAbierto: false,
}

export const key = 'searchNeumaticos/Taller'

const tallerSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    // Para iniciar una búsqueda de talleres
    buscarTalleresStart: (state, action: PayloadAction<string>) => {
      state.loading = true
      state.error = null
      state.busqueda = action.payload
      state.talleresEncontrados = []
      state.modalAbierto = true
    },
    // Cuando la búsqueda es exitosa
    buscarTalleresSuccess: (state, action: PayloadAction<Taller[]>) => {
      state.loading = false
      state.talleresEncontrados = action.payload
    },
    // Cuando hay un error en la búsqueda
    buscarTalleresFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
    // Para seleccionar un taller de la lista
    seleccionarTaller: (state, action: PayloadAction<Taller>) => {
      state.tallerSeleccionado = action.payload
      state.modalAbierto = false // Cierra el modal al seleccionar
    },
    /** Sincroniza el taller sin abrir/cerrar el modal ni disparar búsqueda de resultados. */
    sincronizarTallerSeleccionado: (state, action: PayloadAction<Taller>) => {
      state.tallerSeleccionado = action.payload
    },
    // Para abrir el modal de selección de taller
    abrirModalTaller: (state) => {
      state.modalAbierto = true
    },
    // Para cerrar el modal de selección de taller
    cerrarModalTaller: (state) => {
      state.modalAbierto = false
    },
    // Para restablecer la selección (ej. si el usuario quiere buscar otro)
    resetearTallerSeleccionado: (state) => {
      state.tallerSeleccionado = null
      state.busqueda = ''
    },
    // Para simular la geolocalización y abrir el modal
    geolocalizarStart: (state) => {
      state.loading = true
      state.error = null
      state.modalAbierto = true
    },
  },
})

export const {
  buscarTalleresStart,
  buscarTalleresSuccess,
  buscarTalleresFailure,
  seleccionarTaller,
  sincronizarTallerSeleccionado,
  abrirModalTaller,
  cerrarModalTaller,
  resetearTallerSeleccionado,
  geolocalizarStart,
} = tallerSlice.actions

export default tallerSlice.reducer
